import { render, staticRenderFns } from "./tixi.vue?vue&type=template&id=484720e3&scoped=true"
import script from "./tixi.vue?vue&type=script&lang=js"
export * from "./tixi.vue?vue&type=script&lang=js"
import style0 from "./tixi.vue?vue&type=style&index=0&id=484720e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484720e3",
  null
  
)

export default component.exports